import * as K from 'common/constants';
import ELEMENT, { createTestId } from 'common/element';
import { parseDuration } from 'common/util/time';

import Button, { ButtonVariant } from 'components/common/Button/Button';
import './TimeOptions.scss';

type TimeOptionsProps = {
  header: string;
  options: Array<string>;
  clickHandler: (time: string) => void;
  testId?: ELEMENT;
};

/**
 * This component displays a section with a header and a three-column grid of relative time periods
 * such as '4 hours' or '2 weeks'.
 *
 * @prop header          title for the section
 * @prop options         list of times to display
 * @prop clickHandler    function to run when a time is clicked
 * @prop testId          unique string for testing
 */

function TimeOptions({ header, options, clickHandler, testId }: TimeOptionsProps): JSX.Element {
  const optionEls = options.map((time) => {
    const optionTestId = testId ? createTestId(testId, parseDuration(time) / K.MS_PER_MIN) : undefined;
    return (
      <div key={time} className="TimeOptions__TimeContainer">
        <Button
          variant={ButtonVariant.BORDERLESS}
          className="TimeOptions__Time btn Button Button--Borderless"
          onClick={(): void => clickHandler(time)}
          testId={optionTestId}
        >
          {time}
        </Button>
      </div>
    );
  });

  return (
    <div className="TimeOptions">
      <div className="TimeRangeDropdown__Header uppercase">{header}</div>
      <div className="TimeOptions__Times">{optionEls}</div>
    </div>
  );
}

export default TimeOptions;
